//

import { PoolControllerDynamicAbi } from '@shared/Abis'
import { ChainConfiguration } from '@shared/DeploymentConfigs'
import { LiquidityAsset } from '@shared/LiquidityAsset'
import { logOT } from '@shared/loggingShared'
import { EthAddr, ProviderReadOnly } from '@shared/SchemaTypes'
import { PoolControllerDynamic } from '@typechain-types/index'
import axios from 'axios'
import { Contract } from 'ethers'

export async function poolDynamicStates(params: {
  poolControllerAddr: EthAddr
  providerReadOnly: ProviderReadOnly
}): Promise<{ depositActive: boolean; withdrawActive: boolean }> {
  logOT.debug('poolDynamicStates start', params.poolControllerAddr, PoolControllerDynamicAbi, params.providerReadOnly)
  const poolDynamicControllerContract = new Contract(
    params.poolControllerAddr,
    PoolControllerDynamicAbi,
    params.providerReadOnly
  ) as unknown as PoolControllerDynamic

  const ds = await poolDynamicControllerContract.depositState()

  const depositActive = ds == 0n
  const ws = await poolDynamicControllerContract.withdrawState()

  const withdrawActive = ws == 0n

  return {
    depositActive,
    withdrawActive,
  }
}
export interface GitInfoCTO {
  gitHash: string
  gitBranch: string
  deploymentDate: string
}

export const gitInfoGet = async (
  serverApiBaseUrl: string,
  restAPIKey: string
): Promise<{ aws: GitInfoCTO; react: GitInfoCTO }> => {
  const r = await axios.get(`${serverApiBaseUrl}/gitInfo`, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })

  const aws = r.data as GitInfoCTO

  const response = await axios.get('/gitInfo.json', { headers: { 'Cache-Control': 'no-cache' } })

  const react = response.data as GitInfoCTO

  return { aws, react }
}

export async function fetchLiquidityAssetsForChainConfig(
  chainConfiguration: ChainConfiguration,
  serverApiBaseUrl: string,
  restAPIKey: string,
  refresh?: boolean
): Promise<LiquidityAsset[]> {
  const response = await axios.get(
    refresh
      ? `${serverApiBaseUrl}/liquidityAssets/${chainConfiguration.chainConfigurationName}?refresh=true`
      : `${serverApiBaseUrl}/liquidityAssets/${chainConfiguration.chainConfigurationName}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': restAPIKey,
      },
    }
  )
  logOT.debug('fetchPoolParticipants response', response.data.liquidityAssets)
  return response.data.liquidityAssets || []
}
